<template>
 <div class="margin5 ">
  
  <paddingheader />
  <div v-show="displayfiltir" class="content_setting_search">
    <br/>
   <div v-if="k!='avto'">
     <div class="div_label">{{lang ? 'Калимаҳои калидӣ' : 'Ключевые слова'}}</div>
     <input type="text" class="inputt" v-model.trim="keyworld" @keyup="f_keyup('keyworld')" :placeholder="lang ? 'Калимаҳои калидӣ' : 'Ключевые слова'">
  </div> 


  <br/>
  <div>
     <div class="div_label">{{lang ? 'Ҳамаи шаҳр ва ноҳияҳо' : 'Город или регион'}}</div>
     <div class="div_border">
      <table><tr>
          <td width="100%">
            <router-link :to="{name:'gorodset', params:{set:'1'}}">
               <div v-if="gorod" class="div_placeholder title_overflow">{{gorod_text}}</div>
               <div v-else class="div_placeholder title_overflow">{{lang ? 'Ҳамаи шаҳрҳо' : 'Все города'}}</div>
            </router-link>
          </td>
          <td align="center">
            <div v-if="!gorod">
              <svg width="1.2em" height="1.2em" viewBox="0 0 16 16">
              <g fill="currentColor"><path fillRule="evenodd" clipRule="evenodd" d="M7.976 10.072l4.357-4.357l.62.618L8.284 11h-.618L3 6.333l.619-.618l4.357 4.357z"></path></g></svg>
            </div>
            <div v-else @click="unsert('gorod')">
              <svg  width="1.2em" height="1.2em" viewBox="0 0 24 24">
              <path d="M18.36 19.78L12 13.41l-6.36 6.37l-1.42-1.42L10.59 12L4.22 5.64l1.42-1.42L12 10.59l6.36-6.36l1.41 1.41L13.41 12l6.36 6.36z" fill="currentColor"></path></svg>
            </div>
            <div></div>
          </td>
        </tr></table>
     </div>
     <br/>
  </div>




  <div v-if="k=='avto' || k=='moto' || pk=='avtozapchasti' || pk=='spestexnika' 
            || pk=='motozapchasti'   || pk=='avtobusi'  || pk=='gruzoviki' ">
     <div class="div_label">Марка</div>
     <div class="div_border">
      <table><tr>
          <td width="100%">
            <div v-if="k=='avto' || k=='moto'">
              <router-link :to="{name:'markaset', params:{id:k,set:'1'}}" >
               <div v-if="marka" class="div_placeholder title_overflow">{{marka_text}}</div>
               <div v-else class="div_placeholder title_overflow">{{lang ? 'Ҳамаи маркаҳо' : 'Все марка'}}</div>
              </router-link>
            </div>
            <div v-else-if="pk=='motozapchasti'">
              <router-link :to="{name:'markaset', params:{id:'moto',set:'1'}}" >
               <div v-if="marka" class="div_placeholder title_overflow">{{marka_text}}</div>
               <div v-else class="div_placeholder title_overflow">{{lang ? 'Ҳамаи маркаҳо' : 'Все марка'}}</div>
              </router-link>
            </div>
             <div v-else-if="pk=='avtozapchasti'">
              <router-link :to="{name:'markaset', params:{id:'avto',set:'1'}}" >
               <div v-if="marka" class="div_placeholder title_overflow">{{marka_text}}</div>
               <div v-else class="div_placeholder title_overflow">{{lang ? 'Ҳамаи маркаҳо' : 'Все марка'}}</div>
              </router-link>
            </div>
            <div v-else>
              <router-link :to="{name:'markaset', params:{id:pk,set:'1'}}" >
               <div v-if="marka" class="div_placeholder title_overflow">{{marka_text}}</div>
               <div v-else class="div_placeholder title_overflow">{{lang ? 'Ҳамаи маркаҳо' : 'Все марка'}}</div>
              </router-link>
            </div>
          </td>
          <td align="center">
            <div v-if="!marka">
              <svg width="1.2em" height="1.2em" viewBox="0 0 16 16">
              <g fill="currentColor"><path fillRule="evenodd" clipRule="evenodd" d="M7.976 10.072l4.357-4.357l.62.618L8.284 11h-.618L3 6.333l.619-.618l4.357 4.357z"></path></g></svg>
            </div>
            <div v-else @click="unsert('marka')">
              <svg  width="1.2em" height="1.2em" viewBox="0 0 24 24">
              <path d="M18.36 19.78L12 13.41l-6.36 6.37l-1.42-1.42L10.59 12L4.22 5.64l1.42-1.42L12 10.59l6.36-6.36l1.41 1.41L13.41 12l6.36 6.36z" fill="currentColor"></path></svg>
            </div>
            <div></div>
          </td>
        </tr></table>
     </div>
     <br/>
  </div>
  
  
  <div v-if="k=='avto' && marka">
     <div class="div_label">{{lang ? 'Модел' : 'Модель'}}</div>
     <div class="div_border">
      <table><tr>
          <td width="100%">
            <router-link :to="{name:'modelset', params:{id:marka,set:'1'}}">
               <div v-if="model" class="div_placeholder title_overflow">{{ model_text }}</div>
               <div v-else class="div_placeholder title_overflow">{{lang ? 'Ҳамаи моделҳо' : 'Все модели'}}</div>
            </router-link>
          </td>
          <td align="center">
            <div v-if="!model">
              <svg width="1.2em" height="1.2em" viewBox="0 0 16 16">
              <g fill="currentColor"><path fillRule="evenodd" clipRule="evenodd" d="M7.976 10.072l4.357-4.357l.62.618L8.284 11h-.618L3 6.333l.619-.618l4.357 4.357z"></path></g></svg>
            </div>
            <div v-else @click="unsert('model')">
              <svg  width="1.2em" height="1.2em" viewBox="0 0 24 24">
              <path d="M18.36 19.78L12 13.41l-6.36 6.37l-1.42-1.42L10.59 12L4.22 5.64l1.42-1.42L12 10.59l6.36-6.36l1.41 1.41L13.41 12l6.36 6.36z" fill="currentColor"></path></svg>
            </div>
            <div></div>
          </td>
        </tr></table>
     </div>
     <br/>
  </div>




  <div v-if="k=='moto' || pk=='remont' || pk=='uslugi'  || pk=='spestexnika'
            || pk=='tyning'   || pk=='avtobusi'  || pk=='gruzoviki'">
     <div class="div_label">{{lang ? 'Намуд' : 'Тип'}}</div>
     <div class="div_border">
      <table><tr>
          <td width="100%">
            <div v-if="k=='moto'">
              <router-link :to="{name:'tipset', params:{id:k,set:'1'}}">
                <div v-if="tip" class="div_placeholder title_overflow">{{tip_text }}</div>
                <div v-else class="div_placeholder title_overflow">{{lang ? 'Ҳамаи намуд' : 'Все тип'}}</div>
              </router-link>
            </div>
            <div v-else>
               <router-link :to="{name:'tipset', params:{id:pk,set:'1'}}">
                <div v-if="tip" class="div_placeholder title_overflow">{{tip_text }}</div>
                <div v-else class="div_placeholder title_overflow">{{lang ? 'Ҳамаи намуд' : 'Все тип'}}</div>
              </router-link>
            </div>
          </td>
          <td align="center">
            <div v-if="!tip">
              <svg width="1.2em" height="1.2em" viewBox="0 0 16 16">
              <g fill="currentColor"><path fillRule="evenodd" clipRule="evenodd" d="M7.976 10.072l4.357-4.357l.62.618L8.284 11h-.618L3 6.333l.619-.618l4.357 4.357z"></path></g></svg>
            </div>
            <div v-else @click="unsert('tip')">
              <svg  width="1.2em" height="1.2em" viewBox="0 0 24 24">
              <path d="M18.36 19.78L12 13.41l-6.36 6.37l-1.42-1.42L10.59 12L4.22 5.64l1.42-1.42L12 10.59l6.36-6.36l1.41 1.41L13.41 12l6.36 6.36z" fill="currentColor"></path></svg>
            </div>
            <div></div>
          </td>
        </tr></table>
     </div>
     <br/>
  </div>


  
  <div class="sena_ot_do" >
   <table>
       <tr> <td colspan="1"> <div class="div_label">{{lang ? 'Нарх' : 'Цена'}}</div></td></tr>
       <tr>
           <td>
             <input type="number" class="inputt" v-model.trim="sena_ot" @keyup="f_keyup('sena_ot')" :placeholder="lang ? 'аз' : 'от'">
           </td>
           <td>
             <input type="number" class="inputt" v-model.trim="sena_do" @keyup="f_keyup('sena_do')" :placeholder="lang ? 'то' : 'до'">
           </td>
       </tr>
      </table>    
  </div>
   <br/>
   <div class="sena_ot_do" v-if="k=='moto' || k=='avto'||  pk=='spestexnika'
           || pk=='avtobusi'  || pk=='gruzoviki'">
   <table>
       <tr> <td colspan="1"> <div class="div_label">{{lang ? 'Соли баромад' : 'Год выпуска'}}</div></td></tr>
       <tr>
           <td>
             <input type="number" class="inputt" v-model.trim="god_ot" @keyup="f_keyup('god_ot')" :placeholder="lang ? 'аз' : 'от'">
           </td>
           <td>
             <input type="number" class="inputt" v-model.trim="god_do" @keyup="f_keyup('god_do')" :placeholder="lang ? 'то' : 'до'">
           </td>
       </tr>
      </table>  
      <br/>  
  </div>




  <div v-if=" k=='avto'||  pk=='spestexnika' || pk=='avtobusi'  || pk=='gruzoviki'">
     <div class="div_label">{{lang ? 'Намуди сӯзишворӣ' : 'Тип топлива'}}</div>
     <div class="div_border">
      <table><tr>
          <td width="100%">
            <router-link :to="{name:'toplivaset', params:{set:'1'}}">
               <div v-if="topliva" class="div_placeholder title_overflow">{{topliva_text }}</div>
               <div v-else class="div_placeholder title_overflow">{{lang ? 'Ҳама намуди сӯзишворӣ' : 'Все вид топлива'}}</div>
            </router-link>
          </td>
          <td align="center">
            <div v-if="!topliva">
              <svg width="1.2em" height="1.2em" viewBox="0 0 16 16">
              <g fill="currentColor"><path fillRule="evenodd" clipRule="evenodd" d="M7.976 10.072l4.357-4.357l.62.618L8.284 11h-.618L3 6.333l.619-.618l4.357 4.357z"></path></g></svg>
            </div>
            <div v-else @click="unsert('topliva')">
              <svg  width="1.2em" height="1.2em" viewBox="0 0 24 24">
              <path d="M18.36 19.78L12 13.41l-6.36 6.37l-1.42-1.42L10.59 12L4.22 5.64l1.42-1.42L12 10.59l6.36-6.36l1.41 1.41L13.41 12l6.36 6.36z" fill="currentColor"></path></svg>
            </div>
            <div></div>
          </td>
        </tr></table>
     </div>
     <br/>
  </div>



  <div v-if="k=='avto'">
     <div class="div_label">Кузов</div>
     <div class="div_border">
      <table><tr>
          <td width="100%">
            <router-link :to="{name:'kuzovset', params:{set:'1' }}">
               <div v-if="kuzov" class="div_placeholder title_overflow">{{kuzov_text }}</div>
               <div v-else class="div_placeholder title_overflow">{{lang ? 'Ҳама намуди кузов' : 'Все вид кузов'}}</div>
            </router-link>
          </td>
          <td align="center">
            <div v-if="!kuzov">
              <svg width="1.2em" height="1.2em" viewBox="0 0 16 16">
              <g fill="currentColor"><path fillRule="evenodd" clipRule="evenodd" d="M7.976 10.072l4.357-4.357l.62.618L8.284 11h-.618L3 6.333l.619-.618l4.357 4.357z"></path></g></svg>
            </div>
            <div v-else @click="unsert('kuzov')">
              <svg  width="1.2em" height="1.2em" viewBox="0 0 24 24">
              <path d="M18.36 19.78L12 13.41l-6.36 6.37l-1.42-1.42L10.59 12L4.22 5.64l1.42-1.42L12 10.59l6.36-6.36l1.41 1.41L13.41 12l6.36 6.36z" fill="currentColor"></path></svg>
            </div>
            <div></div>
          </td>
        </tr></table>
     </div>
     <br/>
  </div>



  <div  v-if="k=='avto'">
     <div class="div_label">{{lang ? 'Ранг' : 'Цвет'}}</div>
     <div class="div_border">
      <table><tr>
          <td width="100%">
            <router-link :to="{name:'colorset', params:{set:'1'}}">
               <div v-if="color" class="div_placeholder title_overflow">{{color_text }}</div>
               <div v-else class="div_placeholder title_overflow">{{lang ? 'Ҳама намуди ранг' : 'Все цвет'}}</div>
            </router-link>
          </td>
          <td align="center">
            <div v-if="!color">
              <svg width="1.2em" height="1.2em" viewBox="0 0 16 16">
              <g fill="currentColor"><path fillRule="evenodd" clipRule="evenodd" d="M7.976 10.072l4.357-4.357l.62.618L8.284 11h-.618L3 6.333l.619-.618l4.357 4.357z"></path></g></svg>
            </div>
            <div v-else @click="unsert('color')">
              <svg  width="1.2em" height="1.2em" viewBox="0 0 24 24">
              <path d="M18.36 19.78L12 13.41l-6.36 6.37l-1.42-1.42L10.59 12L4.22 5.64l1.42-1.42L12 10.59l6.36-6.36l1.41 1.41L13.41 12l6.36 6.36z" fill="currentColor"></path></svg>
            </div>
            <div></div>
          </td>
        </tr></table>
     </div>
     <br/>
  </div>


  
  <div  v-if="k=='avto'">
     <div class="div_label">{{lang ? 'Қуттии ивази суръати ҳаракат' : 'Коробка передач'}}</div>
     <div class="div_border">
      <table><tr>
          <td width="100%">
            <router-link :to="{name:'karobkaset', params:{set:'1'}}">
               <div v-if="karobka" class="div_placeholder title_overflow">{{karobka_text}}</div>
               <div v-else class="div_placeholder title_overflow">{{lang ? 'Ҳама намуди қуттии ивази суръати ҳаракат' : 'Все вид каробка передача'}}</div>
            </router-link>
          </td>
          <td align="center">
            <div v-if="!karobka">
              <svg width="1.2em" height="1.2em" viewBox="0 0 16 16">
              <g fill="currentColor"><path fillRule="evenodd" clipRule="evenodd" d="M7.976 10.072l4.357-4.357l.62.618L8.284 11h-.618L3 6.333l.619-.618l4.357 4.357z"></path></g></svg>
            </div>
            <div v-else @click="unsert('karobka')">
              <svg  width="1.2em" height="1.2em" viewBox="0 0 24 24">
              <path d="M18.36 19.78L12 13.41l-6.36 6.37l-1.42-1.42L10.59 12L4.22 5.64l1.42-1.42L12 10.59l6.36-6.36l1.41 1.41L13.41 12l6.36 6.36z" fill="currentColor"></path></svg>
            </div>
            <div></div>
          </td>
        </tr></table>
     </div>
     <br/>
  </div>
   
  <div  v-if="k=='avto'">
     <div class="div_label">{{lang ? 'Масофаи тайшуда то, км' : 'Пробег до, км'}}</div>
     <input type="text" class="inputt" v-model.trim="probeg" @keyup="f_keyup('probeg')" :placeholder="lang ? 'то, км' : 'до, км'">
  </div> 

   <br/><br/><br/><br/><br/>


  </div>
   <div class="content_rezult">
   <div align = "center" v-if="noobv"><h3>{{lang ? 'Ягон эълон ёфта нашуд' : 'Ничего не найдено!'}}</h3></div>
  <div class="content_kart">
    <div v-for="get in getpostfiltirobvs " :key="get.id">
        <Karta  :obvs="get" /> 
    </div>
  </div>
   <div align="center" class="spin" v-if="loading" >
      <Spinner />
  </div>
  <div v-else align="center">
  <button v-if="pei" class="btns" @click="getfiltirobv()">{{lang ? 'Ҳамаашро нишон додан' : 'ПОКАЗАТЬ ЕЩЕ'}}</button>
  </div>
   </div>
   <div ref="observer" class="observer"></div>
  <div >
  <div class="k_search" align="center" v-if="btnfiltir">
      <button  class="btns" @click="getfiltirobv">{{lang ? 'Нишон додан' : 'Показать'}} {{rezultcount}} {{lang ? 'эълонҳо' : 'объявления'}} </button>
  </div>
  </div>  
   <noconnection :propsmodalalert="propsmodalalert" @emitnoconnection="emitnoconnection" />
  <div class="content_head" align="center">
    <div class="main">
    <table  width="100%">
    <tr>
      <td align="left">
       <div onclick="javascript:history.back(); return false;" class="imgback">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--ep" width="30" height="30" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1024 1024">
          <path fill="currentColor" d="M685.248 104.704a64 64 0 0 1 0 90.496L368.448 512l316.8 316.8a64 64 0 0 1-90.496 90.496L232.704 557.248a64 64 0 0 1 0-90.496l362.048-362.048a64 64 0 0 1 90.496 0z"></path></svg></div>
      </td>
      <td align="left"  width="100%">
      <div ><div class="title_overflow"><h1 class='title-h'>{{title}}</h1></div></div>
     </td>
     <td><div @click="f_display_filtir()"><div class="img">  <svg width="30" height="30" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30V8zm-9 4c-1.7 0-3-1.3-3-3s1.3-3 3-3s3 1.3 3 3s-1.3 3-3 3zM2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2zm9-4c1.7 0 3 1.3 3 3s-1.3 3-3 3s-3-1.3-3-3s1.3-3 3-3z"/></svg></div></div></td>	   
    </tr>
    </table>
    </div>
</div>
  </div> 
</template>

<script>
import Spinner from '../blocks/spinner';
import paddingheader from '../blocks/paddingheader';
import noconnection from '../blocks/noconnection';
import Karta from '../blocks/karta';
import axios from "axios";
export default {
 
  components:{
     paddingheader, noconnection, Spinner, Karta
  },
  data() {
     return {
      title: "",
      kateg:"",
      podkateg:"",
      keyworld:"",
      propsmodalalert:false,
      sena_ot:"",
      sena_do:"",
      gorod:"",
      gorod_text:"",
      god_ot:"",
      god_do:"",
      probeg:"",
      rezultcount:"",
      loading:false,
      loadingbtn:true,
      pauza:1000,
      pauz:200,
      timer:"",
      noobv:false,
      displayfiltir:true,
      btnfiltir:true,
      p:false,
      propskate:"",
      propspodkate:"",
      allgrord:"",
      pei:false,
      k:this.$route.params.k,
      pk:this.$route.params.pk,
      ppk:this.$route.params.ppk,
      lang:false,

    };
  },
  computed: {
    getpostfiltirobvs(){
    return this.$store.getters.getpostfiltirobvs
   },
   getgorod(){
    return this.$store.getters.getsetgorod;
   },
   getgorod_text(){
    return this.$store.getters.getsetgorod_text;
   },
   marka(){
    return this.$store.getters.getsetmarka;
   },
   marka_text(){
    return this.$store.getters.getsetmarka_text;
   },
   model(){
    return this.$store.getters.getsetmodel;
   },
   model_text(){
    return this.$store.getters.getsetmodel_text;
   },
   color(){
    return this.$store.getters.getsetcolor;
   },
   color_text(){
    return this.$store.getters.getsetcolor_text;
   },
   karobka(){
    return this.$store.getters.getsetkarobka;
   },
   karobka_text(){
    return this.$store.getters.getsetkarobka_text;
   },
   kuzov(){
    return this.$store.getters.getsetkuzov;
   },
   kuzov_text(){
    return this.$store.getters.getsetkuzov_text;
   },
   topliva(){
    return this.$store.getters.getsettopliva;
   },
   topliva_text(){
    return this.$store.getters.getsettopliva_text;
   },
   tip(){
    return this.$store.getters.getsettip;
   },
   tip_text(){
    return this.$store.getters.getsettip_text;
   },
   getgod_ot(){
    return this.$store.getters.getsetgod_ot;
   },
   getgod_do(){
    return this.$store.getters.getsetgod_do;
   },
    getsena_ot(){
    return this.$store.getters.getsetsena_ot;
   },
   getsena_do(){
    return this.$store.getters.getsetsena_do;
   },
   getkeyworld(){
    return this.$store.getters.getsetkeyworld;
   },
   getprobeg(){
    return this.$store.getters.getsetprobeg;
   },
   },
  methods: {
   f_display_filtir(){
      this.$store.commit("addpostfiltirobvs",new Array); 
      this.$store.commit("addpostobv",new Array);
      this.$store.commit("addpostimgobv",new Array);
      this.displayfiltir=true;
      this.btnfiltir=true;
      this.getcountobv();
    },
   emitnoconnection(){
      this.propsmodalalert=false; 
      this.getcountobv();
   },
   unsert(value){
    if(value=='gorod'){
     this.$store.commit("addsetgorod",""); 
     this.$store.commit("addsetgorod_text","");
     this.gorod="";
     this.gorod_text=""; 
    }
    if(value=='marka'){
     this.$store.commit("addsetmarka",""); 
     this.$store.commit("addsetmarka_text","");
     this.$store.commit("addsetmodel",""); 
     this.$store.commit("addsetmodel_text","");  
    }
    if(value=='model'){
     this.$store.commit("addsetmodel",""); 
     this.$store.commit("addsetmodel_text",""); 
    }
    if(value=='topliva'){
     this.$store.commit("addsettopliva",""); 
     this.$store.commit("addsettopliva_text",""); 
    }
    if(value=='kuzov'){
     this.$store.commit("addsetkuzov",""); 
     this.$store.commit("addsetkuzov_text",""); 
    }
    if(value=='color'){
     this.$store.commit("addsetcolor",""); 
     this.$store.commit("addsetcolor_text",""); 
    }
    if(value=='karobka'){
     this.$store.commit("addsetkarobka",""); 
     this.$store.commit("addsetkarobka_text",""); 
    }
    clearTimeout(this.timer);
    this.timer = setTimeout ( () => {
    this.getcountobv(); 
    }, this.pauza);
   },
   f_keyup(value){
    if(value=='god_ot'){
     this.$store.commit("addsetgod_ot",this.god_ot); 
    }
    if(value=='god_do'){
     this.$store.commit("addsetgod_do",this.god_do); 
    }
    if(value=='sena_ot'){
     this.$store.commit("addsetsena_ot",this.sena_ot); 
    }
    if(value=='sena_do'){
     this.$store.commit("addsetsena_do",this.sena_do); 
    }
    if(value=='keyworld'){
     this.$store.commit("addsetkeyworld",this.keyworld); 
    }
    if(value=='probeg'){
     this.$store.commit("addsetprobeg",this.probeg); 
    }
    clearTimeout(this.timer);
    this.timer = setTimeout ( () => {
    this.getcountobv(); 
    }, this.pauza);
   },
   getcountobv(){
    clearTimeout(this.timer);
     this.timer = setTimeout ( () => {
     this.loadingbtn=true;
     this.noobv=false;
     axios({
           method: 'post',
            url: 'https://avtobaza.tj/api/getcountobv',
            data: {
                gorod:this.gorod,
                k:this.k,
                pk:this.pk,
                ppk:this.ppk,
                marka:this.marka,  
                model:this.model,
                god_ot:this.god_ot,
                god_do:this.god_do,
                sena_ot:this.sena_ot,
                sena_do:this.sena_do,
                keyworld:this.keyworld,
                kuzov:this.kuzov,
                color:this.color,
                topliva:this.topliva,
                karobka:this.karobka,
                probeg:this.probeg,
                tip:this.tip,
            }
          })
        .then(res=>{
            if(res.data.status){           
               this.loadingbtn=false;
               this.btnfiltir=true;
               this.rezultcount="( "+res.data.countobv + " )";   
               this.p=true;
             }
            else{
             this.loading=false;
            }
           }).catch(error => {
           if (!error.response) {
           this.propsmodalalert=true;
          }
        })
        }, this.pauz);
      },
 getfiltirobv(){
    if(this.p){
     this.loading=true;
     this.noobv=false;
     this.displayfiltir=false;
     this.btnfiltir=false;
     axios({
           method: 'post',
            url: 'https://avtobaza.tj/api/getfiltirobv',
            data: {
                  gorod:this.gorod,
                  k:this.k,
                  pk:this.pk,
                  ppk:this.ppk,
                  marka:this.marka,  
                  model:this.model,
                  god_ot:this.god_ot,
                  god_do:this.god_do,
                  sena_ot:this.sena_ot,
                  sena_do:this.sena_do,
                  keyworld:this.keyworld,
                  kuzov:this.kuzov,
                  color:this.color,
                  topliva:this.topliva,
                  karobka:this.karobka,
                  probeg:this.probeg,
                  tip:this.tip,
                  limit:this.getpostfiltirobvs.length,
            } 
          })
        .then(res=>{
            if(res.data.status){           
               
                   if(this.rezultcount > 20){this.pei=true;}
                   if(!this.gorod){
                   localStorage.removeItem('gorod_text');
                   localStorage.removeItem('gorod');
                   this.$cookie.delete('gorod');
                   this.$cookie.delete('gorod_text');
                   }
                   else{
                   localStorage.setItem('gorod_text', this.gorod_text);
                   localStorage.setItem('gorod', this.gorod);
                    this.$cookie.set('gorod', this.gorod, { expires: '2Y' });
                    this.$cookie.set('gorod_text', this.gorod_text, { expires: '2Y' });
                   }

               if(!this.sena_ot && !this.sena_do && !this.keyworld
                 && !this.god_ot && !this.god_do  && !this.probeg && !this.color
                 && !this.topliva && !this.kuzov  && !this.karobka && !this.color
                 ){
                if(!this.gorod) this.gorod='tajikistan';
                  this.pei=false;
                  if(this.k=='avto'){
                    if(this.model){
                        document.location.href = "https://avtobaza.tj/"+this.k+"/"+this.marka+"/"+this.model+"/"+this.gorod+"/1";
                    }
                    else if(this.marka){
                        document.location.href = "https://avtobaza.tj/"+this.k+"/"+this.marka+"/"+this.gorod+"/1";
                    }
                    else{
                        document.location.href = "https://avtobaza.tj/"+this.k+"/"+this.gorod+"/1";
                    }
                  }
                  else if(this.k=='moto'){
                    if(this.tip){
                        document.location.href = "https://avtobaza.tj/"+this.k+"/"+this.tip+"/"+this.gorod+"/1";
                    }
                    else{
                        document.location.href = "https://avtobaza.tj/"+this.k+"/"+this.gorod+"/1";
                    }
                  }
                  else {
                    if(!this.marka && !this.tip){
                      if(this.pk){
                          document.location.href = "https://avtobaza.tj/"+this.k+"/"+this.pk+"/"+this.gorod+"/1";
                      }
                      else if(this.k) document.location.href = "https://avtobaza.tj/"+this.k+"/"+this.gorod+"/1";
                      else document.location.href = "https://avtobaza.tj"
                    }
                    else{
                      this.loading=false;
                      this.displayfiltir=false;
                      this.$store.commit("addpostfiltirobvs",res.data.obvs);
                    }
                  }
                }
                else {
                  this.loading=false;
                  this.displayfiltir=false;
                  this.$store.commit("addpostfiltirobvs",res.data.obvs);
                } 
             }
              else{
                this.p=false;
                if(this.getpostfiltirobvs=="") this.noobv=true;
                this.loading=false;
                this.pei=false;
              }
           }).catch(error => {
           if (!error.response) {
           this.propsmodalalert=true;
          }
        })
      }
    }
  },
   
  mounted(){   
     this.$store.commit("addpostobv",new Array);
     this.$store.commit("addpostimgobv",new Array);
     if(localStorage.getItem("gorod")) {
       this.gorod=String(localStorage.getItem("gorod"));
     }
     
     if(localStorage.getItem("gorod")){
      this.gorod=localStorage.getItem("gorod");
      this.gorod_text=localStorage.getItem("gorod_text");
     }
     if(this.$cookie.get("lang")=="tj"){
        this.lang=true;
     }
     this.title=this.lang ? 'Филтри ҷустуҷӯ' : 'Фильтр поиска';
     if(this.getgod_ot){
       this.god_ot=this.getgod_ot;
     }
     if(this.getgod_do){
       this.god_do=this.getgod_do;
     }
     if(this.getgorod){
       this.gorod=this.getgorod;
     }
     else this.gorod=localStorage.getItem('gorod');
     if(this.getgorod_text){
       this.gorod_text=this.getgorod_text;
     }
     else this.gorod_text=localStorage.getItem('gorod_text');
     if(this.getsena_ot){
       this.sena_ot=this.getsena_ot;
     }
     if(this.getsena_do){
       this.sena_do=this.getsena_do;
     }
     if(this.getprobeg){
       this.probeg=this.getprobeg;
     }
     if(this.getkeyworld){
       this.keyworld=this.getkeyworld;
     }
      
     if(this.getpostfiltirobvs==""){
        this.getcountobv();
     } 
     else{
       this.displayfiltir=false;
       this.btnfiltir=false;
       this.loading=false; 
     }
     const options = {
     rootMargin: '500px',
     threshold: 1.0
     }
     const callback = (entries)=> {
     if(entries[0].isIntersecting){
       if(this.getpostfiltirobvs !=""){
        this.getfiltirobv();
        this.pei=false;
       } 
      }
     };
      const observer = new IntersectionObserver(callback, options);
      observer.observe(this.$refs.observer);
  },
};
</script>

<style scoped>
.content_rezult{
  background-color: #fff;
  margin-left:-5px;
  margin-right: -5px;
}
.k_search{
display:block-inline;
bottom:0px;
padding-top:10px;
margin: 0px;
left:0px;
position: fixed;
min-width:100%;
max-width:100%;
background-color: #fff;
border-top: 1px  solid #ccc;
height: 60px;
}
.margin5{
  margin: 5px;
}
.sena_ot_do {
margin-left:-1px;
}
.sena_ot_do table{
width: 100%;
border-collapse: collapse;
}
.sena_ot_do table td{
width: 50%;
}
.content_upload_img{
height:150px;
}
.sena_ot_do input {
  width: 91%;
}
.inputt {
  width:95.5%;
  border: 1px solid #444;
  padding:10px 0px 10px 10px;
  font-size: 18px;
  border-radius: 5px;
}
.div_placeholder{
  font-size: 18px;
  color:#222;
  margin-left:3px;
}
.div_label{
  font-size: 18px;
  color:#0b76ef;
  margin-left:3px;
}
.content_head {
height:56px;
left: 0px;
top:0px;
padding-top:0px;
position: fixed;
min-width:100%;
max-width:100%;
background-color:#fff;
box-shadow: 0 0 4px 0 rgba(0,0,0,1);
z-index: 1000;
}
.content_head .main {
  max-width: 900px;
  min-width: 250px;
  margin: 0 auto;
}
.title-h {
font-size: 20px;
text-decoration: none;
color:#222;
}
.content_head .img {
color:#555;
margin-right:5px;
margin-top:2px;
}

.title_overflow{
overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
}
.div_border {
   width:96.5%;
  border: 1px solid #444;
  padding:4px 0px 4px 5px;
  font-size: 18px;
  border-radius: 5px;
}
.div_border svg {
  color:#444;
  margin: 3px 3px 0px 3px;
}
.div_border:hover {
cursor:pointer;
}
.content_setting_search{
  max-width: 600px;
  margin: 0 auto;
}
</style>
